module.exports = __webpack_public_path__ + "img/Character_Ningguang_Thumb.77679910.png";